/* =====================================================================
   INDUCTION HARDWARE — WHAT'S HAPPENING INTERACTIONS
   Vanilla JS. Live tag filter + search, reveal-on-scroll, newsletter toast.
===================================================================== */
(function () {
  /* ---------- Live filter + search ---------- */
  var pills = Array.prototype.slice.call(document.querySelectorAll('.pill'));
  var cards = Array.prototype.slice.call(document.querySelectorAll('.post-card'));
  var featured = document.getElementById('featured');
  var searchInput = document.getElementById('postSearch');
  var searchWrap = document.querySelector('.search');
  var searchClear = document.getElementById('searchClear');
  var countEl = document.getElementById('postsCount');
  var emptyEl = document.getElementById('postsEmpty');
  var pager = document.getElementById('pager');
  var postsHeadTitle = document.getElementById('postsHeadTitle');

  var activeTag = 'all';
  var query = '';

  function matchesTag(el, tag) {
    if (tag === 'all') return true;
    var tags = (el.getAttribute('data-tags') || '').split('|');
    return tags.indexOf(tag) !== -1;
  }
  function matchesQuery(el, q) {
    if (!q) return true;
    return (el.getAttribute('data-search') || '').indexOf(q) !== -1;
  }

  function apply() {
    var filtering = (activeTag !== 'all' || query !== '');
    var visible = 0;

    if (featured) {
      featured.classList.toggle('is-hidden', filtering);
    }

    cards.forEach(function (card) {
      var isFeaturedDupe = card.getAttribute('data-featured') === 'true';
      var show;
      if (!filtering) {
        show = !isFeaturedDupe;
      } else {
        show = matchesTag(card, activeTag) && matchesQuery(card, query);
      }
      card.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });

    if (countEl) countEl.textContent = visible + (visible === 1 ? ' story' : ' stories');
    if (emptyEl) emptyEl.classList.toggle('is-shown', visible === 0);
    if (pager) pager.classList.toggle('is-hidden', filtering);

    if (postsHeadTitle) {
      if (activeTag !== 'all') {
        var label = pills.filter(function (p) { return p.getAttribute('data-tag') === activeTag; })[0];
        postsHeadTitle.textContent = label ? label.getAttribute('data-label') : 'Filtered stories';
      } else if (query) {
        postsHeadTitle.textContent = 'Search results';
      } else {
        postsHeadTitle.textContent = 'More stories';
      }
    }
  }

  function setPillCounts() {
    pills.forEach(function (pill) {
      var tag = pill.getAttribute('data-tag');
      var countSpan = pill.querySelector('.pill__count');
      if (!countSpan) return;
      var n = tag === 'all'
        ? cards.filter(function (c) { return c.getAttribute('data-featured') !== 'true'; }).length
        : cards.filter(function (c) { return matchesTag(c, tag); }).length;
      countSpan.textContent = n;
    });
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      activeTag = pill.getAttribute('data-tag');
      apply();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      query = searchInput.value.trim().toLowerCase();
      if (searchWrap) searchWrap.classList.toggle('has-value', query !== '');
      apply();
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      searchInput.value = ''; query = '';
      if (searchWrap) searchWrap.classList.remove('has-value');
      searchInput.focus();
      apply();
    });
  }

  var resetBtn = document.getElementById('resetFilters');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      activeTag = 'all'; query = '';
      if (searchInput) searchInput.value = '';
      if (searchWrap) searchWrap.classList.remove('has-value');
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tag') === 'all');
      });
      apply();
    });
  }

  setPillCounts();
  apply();

  /* ---------- Newsletter toast ---------- */
  var nlForm = document.getElementById('newsletterForm');
  var toast = document.getElementById('toast');
  if (nlForm && toast) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      toast.classList.add('show');
      nlForm.reset();
      setTimeout(function () { toast.classList.remove('show'); }, 2600);
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.ih-newsroom .reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
})();
